module.exports = __webpack_public_path__ + "static/media/b4.96da10c3.jpg";